import { Action } from "../actions/types"
import { DocumentMasterType, DocumentMasterActionList } from "../actions/documentMasterActions"

const initialValue: Array<DocumentMasterType> = []

const documentMasterReducer = (state: Array<DocumentMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case DocumentMasterActionList.ADD_DOCUMENT_MASTER:
            return [
                ...state,
                action.data,
            ]

        case DocumentMasterActionList.UPDATE_DOCUMENT_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case DocumentMasterActionList.FETCH_DOCUMENT_MASTER:
            return action.data

        case DocumentMasterActionList.DELETE_DOCUMENT_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default documentMasterReducer